"use client";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ToastService from "../services/ToastService";
import axiosInstance from "./../api/axiosInstance";
import { RiGoogleLine } from "@remixicon/react";

import { signInWithGooglePopup, auth } from "./../services/firebase";
import { useDispatch } from "react-redux";
import { login } from "../store/userSlice";


const clientId = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;

const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleRegistrationRedirect = () => {
    // Navigate to login page using React Router
    navigate("/registration");
  };
  const handleForgotPasswordRedirect = () => {
    // Navigate to login page using React Router
    navigate("/forgot-password");
  };

  const logGoogleUser = async () => {
    try {
      const response = await signInWithGooglePopup();
      console.log(response);
      const responseData = await axiosInstance.post("/auth/firebase/login", {
        accessToken: response.user.accessToken,
      });

      dispatch(login(responseData.data));

      ToastService.Success("Welcome back !" + responseData.data.name);

      navigate("/");

      // Lưu thông tin user hoặc JWT từ backend (nếu có)
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      console.log(error)
      ToastService.Error(error.message);
    }
  };

  return (
    <>
      <main data-router-wrapper>


        <section
          className="js-page page login is-abyss-form-page is-full-height"
          data-router-view="login"
        >
          <div className="radial-glow is-radial-glow-red"></div>
          <div className="radial-glow is-radial-glow-blue"></div>
          <div className="radial-glow is-radial-glow-purple"></div>

          <div className="page-content">
            <div className="container">
              <form className="js-abyss-form abyss-form" accept-charset="UTF-8">
                <h1 className="page-title">Login</h1>
                {/* 
                <fieldset>
                  <div className="input-group is-input-text has-icon js-input-group ">
                    <div className="border"></div>
                    <div className="label">
                      <span className="value">Email</span>*
                    </div>
                    <div className="icon">
                      <svg
                        width="20"
                        height="16"
                        viewBox="0 0 20 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.6875 2.75L9.35964 7.54025C9.74489 7.81684 10.2551 7.81684 10.6404 7.54025L17.3125 2.75M3.25 15H16.75C17.9926 15 19 13.9553 19 12.6667V3.33333C19 2.04467 17.9926 1 16.75 1H3.25C2.00736 1 1 2.04467 1 3.33333V12.6667C1 13.9553 2.00736 15 3.25 15Z"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <input
                      className="js-input input-text"
                      type="email"
                      name="email"
                      value=""
                    />
                  </div>

                  <div className="input-group is-input-text has-icon js-input-group ">
                    <div className="border"></div>
                    <div className="label">
                      <span className="value">Password</span>*
                    </div>
                    <div className="icon">
                      <svg
                        width="16"
                        height="21"
                        viewBox="0 0 16 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.99922 8V7.08571C2.99922 4.0468 3.99883 1 7.99883 1C11.9988 1 13 3.96109 13 7L13.0012 8M2.99922 8C2.00922 8 0.998047 8.99429 0.998047 10V18C0.998047 19.0057 2.00922 20 2.99922 20H13.0012C13.9912 20 15 19.0057 15 18V10C15 8.99429 13.9912 8 13.0012 8M2.99922 8H13.0012M7.99883 15V13"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                    <input
                      className="js-input input-text"
                      type="password"
                      name="password"
                    />
                  </div>

                  <p className="helper-text-align-right">
                    <Link to="/forgot-password">
                      Forgot your password?
                    </Link>
                  </p>
                </fieldset>

                <button className="submit abyss-button is-primary">
                  <div className="inner">Start learning</div>
                  <div className="inner is-hover">Start learning</div>
                </button> */}
                <button
                  type="button"
                  onClick={logGoogleUser}
                  className="flex w-full justify-center rounded-lg bg-indigo-600 mt-4 px-3 py-4 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Sign in with Google</button>
              </form>

              <div className="illustration">

                {/* <img
                  className="js-lazy lazy"
                  src="./assets/images/login-illustration.webp"
                  srcset="./../assets/images/login-illustration@2x.webp 2x"
                  width="380 "
                  height="460"
                  alt="Three.js Journey first floor"
                /> */}

              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default LoginForm;
